import { render, staticRenderFns } from "./SystemEdit.vue?vue&type=template&id=16441051&scoped=true&"
import script from "./SystemEdit.vue?vue&type=script&lang=js&"
export * from "./SystemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16441051",
  null
  
)

export default component.exports